import * as React from 'react';

export function SvgImage2(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8 5a.8.8 0 00-.8.8v12.6a.8.8 0 00.8.8h14.4a.8.8 0 00.8-.8V5.8a.8.8 0 00-.8-.8H4.8zM2 5.8A2.8 2.8 0 014.8 3h14.4A2.8 2.8 0 0122 5.8v12.6a2.8 2.8 0 01-2.8 2.8H4.8A2.8 2.8 0 012 18.4V5.8z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.95 8.6a.35.35 0 100 .7.35.35 0 000-.7zm-2.35.35a2.35 2.35 0 114.7 0 2.35 2.35 0 01-4.7 0zM13.993 9.593a1 1 0 011.288-.107l6.3 4.5a1 1 0 11-1.162 1.628l-5.611-4.008-9.301 9.301a1 1 0 11-1.414-1.414l9.9-9.9z"
        fill="currentColor"
      />
    </svg>
  );
}
